import { useCallback, useEffect, useState } from 'react';

// Height of the element the returned ref is attached to.
//
// A callback ref (state-backed), not a useRef object: the tabs that use it
// unmount and remount the measured node on every tab switch, and a plain ref
// with a mount-only effect would keep observing the first, detached node.
export function useMeasuredHeight(min = 200) {
  const [node, setNode] = useState(null);
  const ref = useCallback((el) => setNode(el), []);
  const [height, setHeight] = useState(min);

  useEffect(() => {
    if (!node) return;
    const ro = new ResizeObserver(([entry]) => {
      setHeight(Math.max(min, Math.round(entry.contentRect.height)));
    });
    ro.observe(node);
    return () => ro.disconnect();
  }, [node, min]);

  return [ref, height];
}
